import * as moment from 'moment';
import {Moment} from 'moment';
import {OverdueCollectionProductType, OverdueCollectionType} from './overdue-delivery.model';

export interface OverdueDeliveryCriteria {
  deliveryNumber?: string[];
  shipmentNumber?: string[];
  carrierScacCode?: string;
  carrierVendorNumbers?: string[];
  originGlid?: string[];
  originCity?: string;
  originPostalCode?: string;
  originCountryCode?: string;
  destinationGlid?: string[];
  destinationCity?: string;
  destinationPostalCode?: string;
  destinationCountryCode?: string;
  deliveryDateAfter?: Moment;
  deliveryDateBefore?: Moment;
  deliveryDeadlineAfter?: Moment;
  deliveryDeadlineBefore?: Moment;
  productType?: OverdueCollectionProductType;
  collectionType?: OverdueCollectionType;
  pickCompleted?: boolean | OverdueCollectionType.BOTH;
  blocked?: boolean | OverdueCollectionType.BOTH;
  sot?: boolean | OverdueCollectionType.BOTH;
  carrierAssigned?: boolean | OverdueCollectionType.BOTH;
}

export const defaultCriteria: OverdueDeliveryCriteria = {
  deliveryNumber: [],
  shipmentNumber: [],
  carrierScacCode: null,
  carrierVendorNumbers: [],
  deliveryDeadlineBefore: moment().startOf('day'),
  productType: OverdueCollectionProductType.ALL,
  collectionType: OverdueCollectionType.BOTH,
  pickCompleted: OverdueCollectionType.BOTH,
  blocked: OverdueCollectionType.BOTH,
  sot: OverdueCollectionType.BOTH,
  carrierAssigned: OverdueCollectionType.BOTH
}
